import React, { useEffect, useState } from "react";
import api, { inr, roleLabel } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Coins, Search } from "lucide-react";

const Stat = ({ label, value, tone, testid }) => (
  <div className="rounded-lg border border-border/60 bg-card/60 p-3">
    <p className="eyebrow text-muted-foreground">{label}</p>
    <p className={`font-serif text-xl mt-1 ${tone}`} data-testid={testid}>{inr(value)}</p>
  </div>
);

export const CommissionSummary = () => {
  const [data, setData] = useState({ members: [], totals: { earned: 0, paid: 0, due: 0 } });
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/commission/summary").then((r) => setData(r.data)).catch(() => {}); }, []);
  const rows = data.members.filter((m) => `${m.name} ${m.phone || ""}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <Card className="bg-card/40 border-gold/20 p-5 mb-6" data-testid="commission-summary">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="eyebrow text-gold flex items-center gap-1.5"><Coins className="w-4 h-4" /> Commission — all associate partners (every level)</p>
        <div className="relative w-56"><Search className="w-4 h-4 absolute left-2.5 top-2.5 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search member" className="pl-8 h-9 bg-card/60" data-testid="commission-summary-search" /></div>
      </div>
      <div className="grid grid-cols-3 gap-3 mb-4">
        <Stat label="Total earned" value={data.totals.earned} tone="text-white" testid="cs-total-earned" />
        <Stat label="Total paid" value={data.totals.paid} tone="text-emerald-300" testid="cs-total-paid" />
        <Stat label="Total due" value={data.totals.due} tone="text-gold" testid="cs-total-due" />
      </div>
      <div className="overflow-x-auto max-h-96 overflow-y-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-[#05261D]"><tr className="text-left">
            {["Name", "Type", "Earned", "Got (paid)", "Due"].map((h) => <th key={h} className="eyebrow text-gold px-2 py-2 border-b border-gold/30">{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.id} className="border-b border-border/40" data-testid={`cs-row-${m.id}`}>
                <td className="px-2 py-2 text-white">{m.member_no && <span className="text-gold font-mono text-xs mr-1.5">#{m.member_no}</span>}{m.name}<span className="block text-[10px] text-muted-foreground">{m.phone}</span></td>
                <td className="px-2 py-2 text-xs text-muted-foreground">{m.role === "agent" ? "Associate Partner" : roleLabel(m.role)}</td>
                <td className="px-2 py-2">{inr(m.earned)}</td>
                <td className="px-2 py-2 text-emerald-300">{inr(m.paid)}</td>
                <td className={`px-2 py-2 font-semibold ${m.due > 0 ? "text-gold" : "text-muted-foreground"}`} data-testid={`cs-due-${m.id}`}>{inr(m.due)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-2 py-6 text-center text-xs text-muted-foreground">No members yet.</td></tr>}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-muted-foreground mt-3">Mark individual commissions as paid in the Commission page → Payouts.</p>
    </Card>
  );
};
